export default __webpack_public_path__ + "static/takedown-99378ce95a3eb8132f61f2cb995b1985.png";